import Altadena8x161 from "./tipe8x16 (1).png";
import Altadena8x162 from "./tipe8x16 (2).png";
import Altadena8x163 from "./tipe8x16 (3).png";

const altadena8x16 = [Altadena8x161, Altadena8x162, Altadena8x163];

export default altadena8x16;
